// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperList = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0px;
    border-bottom: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    width: 100%;
  `,
);

export const BoxCount = styled.span<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8.5px;
    background-color: ${
      isDark ? theme.colors.gray['lighter-dark-mode'] : theme.colors.gray.light
    };
    color: ${isDark ? theme.colors.white : theme.colors.base.main};
    border-radius: 5px;
  `,
);
